<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import Multiselect from "vue-multiselect";
import ConfirmationModal from '@/components/confirmationModal';
import { toast, variants } from "@/helpers/toaster";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Izmena grupe",
  },
  data() {
    return {
      name: '',
      budget: '',
      selectedAdministrator: null,
      administrators: [],
      administratorQuery: '',
      types: [],
      selectedTypes: [],
      group: null,
      disabled: false,
    };
  },
  components: {ErrorAlert, Layout, VueBootstrapAutocomplete, Multiselect,ConfirmationModal},
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const adminData = await axios.get('/super-admin/administrators');
      this.administrators = adminData.data;

      const typeData = await axios.get('/super-admin/types') 
      this.types = typeData.data;

      await axios.get(`/super-admin/groups/singleGroup/${this.$route.params.id}`)
        .then(response => {
          const group = response.data;
          this.group = group;

          this.name = group.name;
          this.selectedTypes = group.types;
          this.administratorQuery = group.admin.company_name;
          this.selectedAdministrator = group.admin;
          this.budget = group.budget;
        }).catch((error) => {
          if (error.response && error.response.status === 404) {
            this.disabled = true
          }});
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  watch: {
    administratorQuery(v) {
      if (!this.administrators.find(e => e.company_name === v)) {
        this.selectedAdministrator = null;
      }
    },
  },
  computed: {
    computedTypes() {
      if (!this.types) return [];
      
      return [
        {
          all: "Izaberi sve vrste",
          types: this.types,
        }
      ]
    }
  },
  methods: {
    async submitForm() {
      this.$store.commit('loader/START_LOADING');

      try {
        const req = {
          name: this.name,
          admin_id: this.selectedAdministrator.id,
          types: this.selectedTypes.map(t => t.id),
          budget: this.budget,
        }

        await axios.put(`/super-admin/groups/${this.$route.params.id}`, req);
        toast('Uspešna izmena grupe.', variants.SUCCESS)
        this.cancel();
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.$router.push(`/super-admin/groups`)
    },
    async deleteGroup() {
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.delete(`/super-admin/groups/${this.$route.params.id}`);
        toast('Uspešno brisanje grupe.', variants.SUCCESS)
        this.cancel();
      } catch(e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">
        
        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Naziv
              </label>
              <b-form-input :disabled="disabled" v-model="name"  id="group-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label class="col-form-label mr-2" for="group-administrator-input">Administrator</label>
              <VueBootstrapAutocomplete
                :disabled="disabled"
                class="autocomplete"
                id="group-administrator-input"
                :data="administrators"
                v-model="administratorQuery"
                :serializer="(item) => item.company_name"
                :minMatchingChars="0"
                showOnFocus
                @hit="selectedAdministrator = $event"
              />
            </div>
            
            <div class="form-group">
              <label class="col-form-label mr-2" for="group-administrator-input">Vrste</label>
              <multiselect
                :disabled="disabled"
                id="group-types-input"
                v-model="selectedTypes"
                track-by="id"
                label="name"
                :close-on-select="false" 
                :clear-on-select="false"
                :options="computedTypes"
                :group-select="true" 
                group-values="types" 
                group-label="all"
                open-direction="bottom"
                placeholder="Izaberi vrste"
                :multiple="true">
              </multiselect>
            </div>

            <div class="form-group">
              <label>
                Budžet
              </label>
              <b-form-input :disabled="disabled" v-model="budget" placeholder="" 
                            id="group-administrator-input" type="number"></b-form-input>
            </div>

            <div class="text-right">        
              <confirmation-modal buttonClass="mr-2" variant="danger" message="Da li ste sigurni da želite da izbrišete grupu?" title="Izbriši grupu" buttonText="Izbriši" @onSubmit="deleteGroup" />
              <b-button type="button" variant="secondary" @click="cancel()">Otkaži</b-button>
              <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>

input[type='radio'] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease .3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #FF5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #FFC107;
}

.lime .button span {
  background: #8BC34A;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196F3;
}

.indigo .button span {
  background: #3F51B5;
}

.autocomplete {
  width: 100%
}

</style>
